import { SmartTableComponent } from "../smart-table.component";

export abstract class Action {

    constructor(protected component: SmartTableComponent) { }

    abstract execute(val: any, row?: any, callback?: Function): void;

}